export default __webpack_public_path__ + "static/media/icon-right-round-arrow.34ab6b12.svg";